'use client';

import Image from 'next/image';
import { Button } from "@/components/ui/button";
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

interface CenteredFeatureSectionProps {
  subtitle?: string;
  title?: string;
  description?: string;
}

export function CenteredFeatureSection({
  subtitle,
  title,
  description,
}: CenteredFeatureSectionProps) {
  return (
    <section className="pt-20 md:pt-28 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          {subtitle && (
            <div className="inline-block px-4 py-2 rounded-full bg-primary/10 mb-6">
              <h3 className="text-sm font-heading font-semibold text-primary uppercase tracking-wider">
                {subtitle}
              </h3>
            </div>
          )}
          {title && (
            <h2 
              className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-gray-900 tracking-tight leading-tight mb-6 flex items-start"
            >
              {title}
            </h2>
          )}
          {description && (
            <p 
              className="text-lg font-sans text-gray-600 leading-relaxed mb-12"
            >
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
} 